module.exports = __webpack_public_path__ + "static/media/tata-projects.a12bed99.svg";